import { render, staticRenderFns } from "./OperaPricingDetailWindow.vue?vue&type=template&id=4be96cf6&"
import script from "./OperaPricingDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaPricingDetailWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports